/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.style.constants

import org.jetbrains.compose.web.css.px

/*
 * Inspired by Android grid
 */
val grid0_5 = 2.px
val grid1 = 4.px
val grid2 = 8.px
val grid3 = 12.px
val grid4 = 16.px
val grid5 = 20.px
val grid6 = 24.px
val grid7 = 28.px
val grid8 = 32.px
val grid9 = 36.px
val grid10 = 40.px
val grid11 = 44.px
val grid12 = 48.px
val grid13 = 52.px
val grid14 = 56.px
val grid15 = 60.px
val grid16 = 64.px
val grid17 = 68.px
val grid18 = 72.px
val grid19 = 76.px
val grid20 = 80.px
val grid21 = 84.px
val grid22 = 88.px
val grid23 = 92.px
val grid24 = 96.px
val grid25 = 100.px
val grid26 = 104.px
val grid27 = 108.px
val grid28 = 112.px
val grid29 = 116.px
val grid30 = 120.px
val grid31 = 124.px
val grid32 = 128.px
val grid33 = 132.px
val grid34 = 136.px
val grid35 = 140.px
val grid36 = 144.px
val grid37 = 148.px
val grid38 = 152.px
val grid39 = 156.px
val grid40 = 160.px
val grid41 = 164.px
val grid42 = 168.px
val grid43 = 172.px
val grid44 = 176.px
val grid45 = 180.px
val grid46 = 184.px
val grid47 = 188.px
val grid48 = 192.px
val grid49 = 196.px
val grid50 = 200.px
val grid51 = 204.px
val grid52 = 208.px
val grid53 = 212.px
val grid54 = 216.px
val grid55 = 220.px
val grid56 = 224.px
val grid57 = 228.px
val grid58 = 232.px
val grid59 = 236.px
val grid60 = 240.px
val grid61 = 244.px
val grid62 = 248.px
val grid63 = 252.px
val grid64 = 256.px
val grid65 = 260.px
val grid66 = 264.px
val grid67 = 268.px
val grid68 = 272.px
val grid69 = 276.px
val grid70 = 280.px
val grid71 = 284.px
val grid72 = 288.px
val grid73 = 292.px
val grid74 = 296.px
val grid75 = 300.px
val grid76 = 304.px
val grid77 = 308.px
val grid78 = 312.px
val grid79 = 316.px
val grid80 = 320.px
val grid81 = 324.px
val grid82 = 328.px
val grid83 = 332.px
val grid84 = 336.px
val grid85 = 340.px
val grid86 = 344.px
val grid87 = 348.px
val grid88 = 352.px
val grid89 = 356.px
val grid90 = 360.px
val grid91 = 364.px
val grid92 = 368.px
val grid93 = 372.px
val grid94 = 376.px
val grid95 = 380.px
val grid96 = 384.px
